import * as XLSX from 'xlsx';

export const METER_TABLE_EXPORT_HEADERS = [
  'Sl. No',
  'Meter Number',
  'Qtr No',
  'Area',
  'Depot',
  'State',
  'Installation Date',
  'Field Officer',
  'Status',
  'Latitude',
  'Longitude',
];

export function qtrForExcelExport(qtr) {
  if (qtr == null || qtr === '') return '';
  const s = String(qtr);
  return s.startsWith("'") ? s : `'${s}`;
}

function rawCoordinateForExport(value) {
  if (value == null || value === '') return '';
  return String(value);
}

function meterRowToExportCells(row, index) {
  return [
    index + 1,
    row.meter ?? '',
    qtrForExcelExport(row.qtr),
    row.area ?? '',
    row.depot ?? '',
    row.state ?? '',
    row.date ?? '',
    row.officer ?? '',
    row.status ?? '',
    rawCoordinateForExport(row.latitude),
    rawCoordinateForExport(row.longitude),
  ];
}

/**
 * Download meter rows as an Excel workbook (.xlsx).
 * @param {{ rows: object[], sheetName?: string, fileName: string }} options
 */
export function exportMetersToExcel({ rows, sheetName = 'Meters', fileName }) {
  const safeName = String(fileName || 'meters_export')
    .replace(/[<>:"/\\|?*]+/g, '_')
    .replace(/\s+/g, '_');
  const downloadName = safeName.endsWith('.xlsx') ? safeName : `${safeName}.xlsx`;

  const data = [
    METER_TABLE_EXPORT_HEADERS,
    ...rows.map((row, index) => meterRowToExportCells(row, index)),
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(data);
  const latCol = METER_TABLE_EXPORT_HEADERS.indexOf('Latitude');
  const lngCol = METER_TABLE_EXPORT_HEADERS.indexOf('Longitude');
  for (let r = 1; r < data.length; r += 1) {
    for (const c of [latCol, lngCol]) {
      if (c < 0) continue;
      const ref = XLSX.utils.encode_cell({ r, c });
      const cell = worksheet[ref];
      if (!cell || cell.v === '') continue;
      cell.t = 's';
      cell.v = String(cell.v);
      cell.z = '@';
    }
  }
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName.slice(0, 31));
  XLSX.writeFile(workbook, downloadName);
}
